<template>
  <div class="road-car" :style="style">
    <div class="car-bounce">
      <!-- Little red car SVG -->
      <svg width="48" height="30" viewBox="0 0 48 30" fill="none" class="drop-shadow-lg">
        <!-- Car body -->
        <rect x="4" y="10" width="40" height="14" rx="4" fill="#ef4444" />
        <!-- Car roof/cabin -->
        <path d="M14,10 L18,2 L34,2 L38,10" fill="#dc2626" />
        <!-- Windshield -->
        <path d="M19,3 L17,9 L25,9 L25,3 Z" fill="#bfdbfe" opacity="0.8" />
        <!-- Rear window -->
        <path d="M27,3 L27,9 L35,9 L33,3 Z" fill="#bfdbfe" opacity="0.8" />
        <!-- Front bumper -->
        <rect x="1" y="14" width="6" height="6" rx="2" fill="#b91c1c" />
        <!-- Rear bumper -->
        <rect x="41" y="14" width="6" height="6" rx="2" fill="#b91c1c" />
        <!-- Headlight -->
        <circle cx="4" cy="16" r="2" fill="#fbbf24" />
        <!-- Tail light -->
        <circle cx="44" cy="16" r="2" fill="#fca5a5" />
        <!-- Front wheel -->
        <circle cx="14" cy="24" r="5" fill="#1e293b" />
        <circle cx="14" cy="24" r="2.5" fill="#64748b" />
        <!-- Rear wheel -->
        <circle cx="36" cy="24" r="5" fill="#1e293b" />
        <circle cx="36" cy="24" r="2.5" fill="#64748b" />
        <!-- Speed lines -->
        <line x1="46" y1="12" x2="52" y2="12" stroke="#fbbf24" stroke-width="1.5" opacity="0.6" />
        <line x1="46" y1="16" x2="54" y2="16" stroke="#fbbf24" stroke-width="1" opacity="0.4" />
        <line x1="46" y1="20" x2="51" y2="20" stroke="#fbbf24" stroke-width="1.5" opacity="0.6" />
      </svg>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  x: { type: Number, required: true },
  y: { type: Number, required: true }
});

const style = computed(() => ({
  position: 'absolute',
  left: `${props.x - 24}px`,
  top: `${props.y - 38}px`,
  transition: 'left 0.6s ease, top 0.6s ease',
  zIndex: 20,
  pointerEvents: 'none'
}));
</script>

<style scoped>
.car-bounce {
  animation: car-drive 1.5s ease-in-out infinite;
}

@keyframes car-drive {
  0%, 100% { transform: translateY(0) rotate(0deg); }
  25% { transform: translateY(-2px) rotate(-0.5deg); }
  75% { transform: translateY(-1px) rotate(0.5deg); }
}
</style>
